/* global $, google */
import template from './template.js';
import templateGM from './templateGM.js';
import peers from './bases.js';
import language from './language.js';

export default class SearchResultsList {
  constructor(field) {
    this.field = field;
    this.node = null;
    this.clicked = false;
    this.showList = true;
    this.geocoder = null;
    this.init();
  }

  init() {
    this.node = $(document.getElementsByName(this.field)[0]).next().children().children();
    this.geocoder = new google.maps.Geocoder();
    $(document).click((event) => {
      if ($(event.target).closest('.searchResult').length > 0) {
        this.hide();
        event.stopPropagation();
      }
    });
  }

  show(data) {
    const result = data.slice(0, 5).map((el) => {
      const element = peers.base[el.ref];
      return {
        name: element[language],
        _id: element._id, // eslint-disable-line no-underscore-dangle
        sortOrder: element.sortOrder,
      };
    });
    const sortedResult = result.sort((a, b) => {
      if (a.sortOrder < b.sortOrder) return -1;
      if (a.sortOrder > b.sortOrder) return 1;
      return 0;
    });
    if (!this.clicked) {
      this.node.html('').json2html(sortedResult, template, {
        append: false,
      });
    }
    $('.searchResult li').off();
    this.bindClickEvent('custom');
    if (this.showList) {
      this.showList = false;
      $(document.getElementsByName(this.field)[0]).next().fadeIn(150);
    }
  }

  showGoogle(data) {
    // console.log('data,this.showList',data,this.showList);
    const result = data.map((element) => {
      const el = element;
      const mStrings = el.matched_substrings[0];
      return {
        description: el.description,
        before: el.terms[0].value.substr(0, mStrings.offset),
        match: el.terms[0].value.substr(mStrings.offset, mStrings.length),
        name: el.terms[0].value.slice(mStrings.offset + mStrings.length),
        address: el.terms.reduce((addr, addrEl, i) => (i > 0 ? `${addr} ${addrEl.value}` : addr), ''),
        place_id: el.place_id,
      };
    });
    if (!this.clicked) {
      // console.log('result',result);
      this.node.html('').json2html(result, templateGM, {
        append: false,
      });
    }
    $('.searchResult li').off();
    this.bindClickEvent('google');
    if (this.showList) {
      this.showList = false;
      $(document.getElementsByName(this.field)[0]).next().fadeIn(150);
    }
  }

  hide() {
    this.showList = true;
    $(document.getElementsByName(this.field)[0]).next().fadeOut(100);
    $('.searchResult li').off();
  }

  bindClickEvent(type) {
    const self = this;
    if (type === 'custom') {
      $('.searchResult li').click(function handler() {
        // self.clicked = true;
        $(this).parent().parent().parent().prev().val($(this).text());
        $(`input[name="${self.field}Id"]`).val($(this).data('id'));
        document.getElementsByName(`${self.field}Data`)[0].value = '';
        self.hide();
      });
    } else {
      $('.searchResult li').click(function handler() {
        document.getElementsByName('action')[0].value = 'newform';
        self.hide();
        document.getElementsByName(self.field)[0].value = this.dataset.value;
        self.geocoder.geocode({ placeId: this.dataset.id, language: 'en', region: 'it' }, (results, status) => {
          if (status === google.maps.GeocoderStatus.OK) {
            const place = results[0];
            const placeData = {};
            placeData.formatted_address = place.formatted_address;
            placeData.name = place.name;
            placeData.city = place.address_components.filter((el) =>
              el.types[0] === 'locality' || el.types[0] === 'administrative_area_level_3'
            );
            $(`input[name="${self.field}Id"]`).val('');
            document.getElementsByName(`${self.field}Data`)[0].value = JSON.stringify(placeData);
          } else {
            console.log(`Can't find address: ${status}`); // eslint-disable-line no-console
          }
        });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./public/scripts/webpack/SearchResultsList.js